import { render, staticRenderFns } from "./UploadVinculaEntregaCorreioNFe.vue?vue&type=template&id=6927e5cb&"
import script from "./UploadVinculaEntregaCorreioNFe.vue?vue&type=script&lang=js&"
export * from "./UploadVinculaEntregaCorreioNFe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports